import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Inset } from 'syf-component-library/ui/spacing';
import { useEffect } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import triggerPaymentSecurityAnalytics from '../../../../../helpers/trigger-payment-security-analytics';
import { PAGE_NAME } from '../../../../../const/analytics';
import { ScreenWrapper } from '../subcomponents';
import PaymentSecurityHeader from '../../header';
import Content from '../../../../common/content';
import SectionDetail from '../../../../common/section-detail';
import PaymentSecurityDebtCancellation from '../../../../common/payment-debt-cancellation';
import ManagePaymentSecurityLink from './subcomponents';
import { usePaymentSecurityContext } from '../../../../../context';
const AlreadyEnrolled = () => {
    const { t } = useTranslation();
    const { showPopup } = usePaymentSecurityContext();
    const linkText = t('alreadyEnrolled.howCanICancel.linkText');
    const managePaymentSecurityLink = (_jsx(ManagePaymentSecurityLink, { "aria-labelledby": "manage-payment-security-link", buttonType: "text", "data-analytics": "clicktrackingevent", "data-object": "button", "data-reason": "managing payment security", "data-type": "payment security", onClick: () => showPopup(), title: linkText, children: linkText }));
    useEffect(() => {
        triggerPaymentSecurityAnalytics({
            pageName: PAGE_NAME.ALREADY_ENROLLED
        });
    }, []);
    return (_jsxs(ScreenWrapper, { children: [_jsx(PaymentSecurityHeader, { title: t('alreadyEnrolled.header.title'), subtitle: t('common.header.subtitle') }), _jsx(Inset, { top: "large", children: _jsxs(Content, { children: [_jsx(SectionDetail, { title: t('alreadyEnrolled.howCanICancel.title'), primaryDescription: _jsx(Trans, { i18nKey: "alreadyEnrolled.howCanICancel.body", components: { managePaymentSecurityLink }, values: { linkText } }) }), _jsx(PaymentSecurityDebtCancellation, {})] }) })] }));
};
export default AlreadyEnrolled;
